import { useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { Check } from "./preparation-types";
import type { SessionUser } from "../../../shared/auth/access";
import { can } from "../../../shared/auth/access";
export function usePreparationCountWorkspace({ check, item, user, onSaved, notify, }: {
    check: Check;
    item: Check["items"][number];
    user: SessionUser;
    onSaved: (check: Check) => void;
    notify: (message: string) => void;
}) {
    const needs = (scope: "MAIN" | "HANDOFF" | "STAGING", legacyLabel: string) => item.differences.some((difference) => (difference.code === "PHYSICAL_COUNT_PENDING" ||
        difference.code === "SYSTEM_PHYSICAL_VARIANCE") &&
        (difference.scope === scope ||
            (!difference.scope && difference.reason.startsWith(legacyLabel))));
    const scopes = [
        can(user, "material.preparation.count.main") && needs("MAIN", "Ana depo")
            ? "MAIN"
            : null,
        can(user, "material.preparation.count.main") &&
            needs("HANDOFF", "Teslim/tesellüm")
            ? "HANDOFF"
            : null,
        can(user, "material.preparation.count.staging") &&
            needs("STAGING", "Cep depo")
            ? "STAGING"
            : null,
    ].filter(Boolean) as Array<"MAIN" | "HANDOFF" | "STAGING">;
    const [values, setValues] = useState<Record<string, string>>({});
    const [saving, setSaving] = useState(false);
    const save = async (scope: "MAIN" | "HANDOFF" | "STAGING") => {
        const quantity = Number(values[scope]);
        if (!Number.isFinite(quantity) || quantity < 0) {
            notify("Fiziki sayım için sıfır veya daha büyük bir miktar girin.");
            return;
        }
        setSaving(true);
        try {
            onSaved(await apiRequest<Check>(`/api/material-preparation/checks/${check.id}/items/${encodeURIComponent(item.materialCode)}/counts`, {
                method: "POST",
                body: JSON.stringify({
                    scope,
                    quantity,
                    unit: item.unit,
                    idempotencyKey: crypto.randomUUID(),
                    expectedVersion: check.version,
                }),
            }));
        }
        catch (error) {
            notify(error instanceof Error ? error.message : "Fiziki sayım kaydedilemedi.");
        }
        finally {
            setSaving(false);
        }
    };
    const scopeLabel = (scope: "MAIN" | "HANDOFF" | "STAGING") => scope === "MAIN"
        ? "Ana depo"
        : scope === "HANDOFF"
            ? "Teslim / tesellüm"
            : "Cep depo";
    return { scopes, values, setValues, saving, save, scopeLabel };
}
